export const SIGN_IN = "auth/login"
export const SIGN_OUT = "auth/logout"
export const FORGOT_PASSWORD = "auth/forgot"
export const SIGN_UP = 'auth/signup'
export const NOTIFICATION = 'user/notification'
export const MY_PROFILE = "user/profile"
export const REMOVE_MESSENGER = "user/remove-fb"

export const UNAUTHORIZED = 401
export const FORBIDDEN = 403